export function LegendKeyCard({ number, title, subtitle, description, status, onStart, buttonLabel }) {
  const isLocked = status === 'locked';
  const isDone = status === 'completed';
  return (
    <div className="rounded-xl border p-6 transition-all" data-testid={`legend-key-${number}`}
      style={{
        background: isDone ? 'rgba(16,185,129,0.04)' : isLocked ? 'rgba(10,7,3,0.5)' : 'rgba(10,7,3,0.8)',
        borderColor: isDone ? 'rgba(16,185,129,0.2)' : isLocked ? 'rgba(100,116,139,0.15)' : 'rgba(212,165,74,0.2)',
        opacity: isLocked ? 0.5 : 1,
      }}>
      <div className="flex items-start justify-between mb-3">
        <div>
          <p className="text-[10px] tracking-[0.3em] uppercase font-bold mb-1" style={{ color: '#dc2626' }}>Legend Key {number}</p>
          <h3 className="text-lg font-bold" style={{ color: isDone ? '#10b981' : '#d4a54a' }}>{title}</h3>
          <p className="text-xs italic" style={{ color: 'rgba(220,190,130,0.4)' }}>{subtitle}</p>
        </div>
        {isDone && (
          <span className="flex items-center gap-1 px-2 py-1 rounded-full text-[9px] tracking-wider flex-shrink-0" style={{ background: 'rgba(16,185,129,0.1)', color: '#34d399', border: '1px solid rgba(16,185,129,0.2)' }}>
            <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
            COMPLETE
          </span>
        )}
        {isLocked && (
          <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="rgba(148,163,184,0.4)" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
        )}
      </div>
      <p className="text-sm leading-relaxed mb-5" style={{ color: isLocked ? 'rgba(220,190,130,0.25)' : 'rgba(220,190,130,0.7)' }}>{description}</p>
      <button
        onClick={onStart}
        disabled={isLocked}
        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-bold transition-all border"
        style={{
          background: isDone ? 'rgba(16,185,129,0.08)' : isLocked ? 'rgba(100,116,139,0.05)' : 'rgba(212,165,74,0.08)',
          borderColor: isDone ? 'rgba(16,185,129,0.25)' : isLocked ? 'rgba(100,116,139,0.1)' : 'rgba(212,165,74,0.3)',
          color: isDone ? '#10b981' : isLocked ? 'rgba(148,163,184,0.4)' : '#d4a54a',
          cursor: isLocked ? 'not-allowed' : 'pointer',
        }}
        data-testid={`btn-legend-key-${number}`}
      >
        {buttonLabel}
        {!isLocked && <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>}
      </button>
    </div>
  );
}
